// The project in context: the one selected on the dashboard, or the one an annotate / train / auto page is open on.
// The desktop keeps its dashboard alive while another page shows, so coming back finds the same project selected; here
// the dashboard is remounted, so the selection lives here. The shell (top bar, side nav) subscribes to it.
import { useSyncExternalStore } from "react";

let id: number | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const getCurrentProjectId = () => id;
export const setCurrentProjectId = (v: number | null) => { if (v !== id) { id = v; emit(); } };

const subscribe = (l: () => void) => { listeners.add(l); return () => { listeners.delete(l); }; };
export const useCurrentProjectId = () => useSyncExternalStore(subscribe, getCurrentProjectId);

/**
 * Something changed the project's images or annotations (an upload, a review, a training run), so counts shown
 * elsewhere (the side nav) should be read again. Like creditsChanged in lib/credits.ts.
 */
export const PROJECT_DATA_CHANGED = "modelbench:project-data-changed";
export const projectDataChanged = () => window.dispatchEvent(new Event(PROJECT_DATA_CHANGED));

/** The project list changed (created, renamed, deleted): the top bar's switcher reads it again. */
export const PROJECTS_CHANGED = "modelbench:projects-changed";
export const projectsChanged = () => window.dispatchEvent(new Event(PROJECTS_CHANGED));
